import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import HeroTitle from '../common/HeroTitle';
import Reveal from 'react-reveal/Reveal';


const HeroCaliber = () => {
 
  return (
    <>
      <section
        className='hero-section ptb-120'        
      >
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-lg-6 col-md-10'>
              <div className='hero-content-wrap mt-5'>
                <HeroTitle
                  title='Amplifying Efficiency and Compliance in Instrument Processes'
                  desc='A comprehensive solution that holistically optimizes all aspects of instrument-related processes, leading to a marked enhancement in operational efficiency and bolstered organizational compliance.'                  
                />          
              
              </div>
            </div>
            <div className='col-lg-6 col-md-8'>
            <Reveal effect="fadeinright">


              <div className='hero-img position-relative circle-shape-images'>             
                {/* <!--animated shape end--> */}
                <img
                  src='assets/img/caliber-banner.png'
                  alt='hero img'
                  className='img-fluid position-relative z-5'
                />
              </div>
              </Reveal>


            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroCaliber;
